import { Response } from "@angular/http";
import { VerificationMethodModel } from "../otp/otp.model";

export class SetupPINRequest {
  pin: string;
  verifiedToken: string;

  constructor(pin: string, verifiedToken?: string) {
    this.pin = pin;
    this.verifiedToken = verifiedToken
  }
}

export class SetupPINResponse {
  status: string;
  verification: VerificationMethodModel[];

  constructor(res: Response) {
    if (res.text()) {
      const data = res.json().data;
      this.status = data.status;
      this.verification = data.verification;
    }
  }
}

export class VerifyPINRequest {
  pin: string;

  constructor(pin: string, verifiedToken?: string) {
    this.pin = pin;
  }
}

export class PINRequest {
  pin: string;
  token: string

  constructor(pin: string, token: string) {
    this.pin = pin;
    this.token = token;
  }
}

export interface PublicKeyResponse {
  key: string;
  token: string;
}

export interface UserPINExistsResponse {
  exists: boolean;
}

export interface VerifyPINResponse {
  verifiedToken: string;
}


// WEBPACK FOOTER //
// ./src/app/model/pin/pin.model.ts